import { extraNetworkActionsCreator } from '../../../../../admincore'

const actions = {
  ...extraNetworkActionsCreator('DESTROY', 'labels/destroy'),
}

export default actions

export function destroy(id) {
  return {
    type: actions.DESTROY,
    payload: {
      id,
    },
  }
}
